import { Outlet } from 'react-router-dom';

import { Auth0Provider } from '@auth0/auth0-react';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const AuthenticationProvider: FunctionComponent<Props> = ({
    authorizationParams,
    clientId,
    domain,
    testId = TEST_ID
}) => (
    <Auth0Provider
        authorizationParams={authorizationParams}
        clientId={clientId}
        data-testid={testId}
        domain={domain}
    >
        <Outlet />
    </Auth0Provider>
);

export default AuthenticationProvider;
